import FailuresTable from "../../default/FailuresTable";
import { FailureStatusFilter } from "api/generated/lumen";
import { FailureListRequestParams } from "features/failures/models";

const fetchDataParams: FailureListRequestParams = {
  statusFilter: FailureStatusFilter.OnlySealed,
};

const TableClosed: React.FC = () => {
  return <FailuresTable fetchDataParams={fetchDataParams} />;
};

export default TableClosed;
